import React, { useState } from "react";
import { Button, Form, Input, Layout } from "antd";

function LoginApp() {
  const [id, setId] = useState('');
  const [password, setPassword] = useState('');

  return (
    <Layout>
      <Layout.Header style={{
        color: '#fff',
        display: 'flex',
        justifyContent: 'center'
      }}>
        초코 웹 시스템
      </Layout.Header>
      <Layout.Content style={{
        padding: '24px 50px',
        background: '#fff',
      }}>
        <div className="login-form" style={{
          padding: '24px',
          minHeight: '300px'
        }}>
          <br />
          <br />
          <br />
          <form method="post" action="/login">
            <Form.Item
              label="ID"
              name="username"
              rules={[{ required: true }]}
              labelCol={{ span: 8 }}
              wrapperCol={{ span: 8 }}
            >
              <Input
                type='text'
                placeholder='아이디를 입력해주세요.'
                name={"username"}
                value={id}
                onChange={(e) => setId(e.target.value)}
              />
            </Form.Item>
            <Form.Item
              label="Password"
              name="password"
              rules={[{ required: true }]}
              labelCol={{ span: 8 }}
              wrapperCol={{ span: 8 }}
            >
              <Input
                type='password'
                name="password"
                placeholder='패스워드를 입력해주세요.'
                value={password}
                onChange={(e) => setPassword(e.target.value)}
              />
            </Form.Item>
            <Form.Item wrapperCol={{ offset: 8, span: 8 }}>
              <Button type={'primary'} htmlType="submit" block>
                로그인
              </Button>
            </Form.Item>
          </form>
        </div>
      </Layout.Content>
    </Layout>
  )
}

export default LoginApp
